import React, { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./lib/firebase";
import GetUser from "./utils/GetUser";
import NotUser from "./utils/NotUser";
import Loader from "./components/Loader";
import Header from "./components/nav/Header";
import Footer from "./components/nav/Footer";
import "./App.css";

const App = () => {
  const [user, setUser] = useState(null); 
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    // Monitor authentication state
    const unsubscribe = onAuthStateChanged(auth, (authUser) => {
      setUser(authUser); // Set user if authenticated, else null
      setLoading(false); // Stop the loader once the check completes
    });

    return () => unsubscribe(); // Cleanup listener on component unmount
  }, []);

  // Display loader while checking authentication
  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <Header /> 
      <div className="top bottom">
        {user ? (
          <GetUser user={user} setUser={setUser} /> 
        ) : (
          <NotUser setUser={setUser} /> 
        )}
      </div>
      <Footer />
    </div>
  );
};

export default App;
